module.exports = __webpack_public_path__ + "static/media/kosovo.cd99b339.png";